import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import { i18n } from '../../translate/i18n';

export const fetchQuestionsSuccess = (questions) => {
  return {
    type: actionTypes.FETCH_QUESTIONS_SUCCESS,
    questions: questions
  };
};

export const requestQuestionsFail = (error) => {
  return {
    type: actionTypes.REQUEST_QUESTIONS_FAIL,
    error: error
  };
};

export const requestQuestionsStart = () => {
  return {
    type: actionTypes.REQUEST_QUESTIONS_START
  };
};

export const deleteQuestionsSuccess = (questions) => {
  return {
    type: actionTypes.DELETE_QUESTIONS_SUCCESS,
    questions: questions
  }
}

export const updateQuestionsSuccess = (questions) => {
  return {
    type: actionTypes.UPDATE_QUESTIONS_SUCCESS,
    questions: questions
  }
}

export const postQuestionsSuccess = () => {
  return {
    type: actionTypes.POST_QUESTIONS_SUCCESS,
  }
}

export const fetchQuestions = (page, limit, search, order, orderBy) => {

  return dispatch => {
    dispatch(requestQuestionsStart());
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    API.get('/questions' + queryParams)
      .then(res => {
        dispatch(fetchQuestionsSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestQuestionsFail(err));
      });
  };
};

export const deleteQuestions = (question) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestQuestionsStart());
      API.put('/questions/' + question._id + '/delete')
        .then(res => {
          dispatch(deleteQuestionsSuccess(res.data.question));
          toastr.success(`${question.type === 'group' ? i18n.t('deleteQuestionsStr.toastrTrue') : i18n.t('deleteQuestionsStr.toastrFalse')} `, `${question.name} ${i18n.t('deleteQuestionsStr.txt')}`)
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestQuestionsFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })
  }
}

export const postQuestions = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestQuestionsStart());
      API.post('/questions', body)
        .then(res => {
          dispatch(postQuestionsSuccess());
          toastr.success(`${body.type === 'group' ? i18n.t('postQuestions.toastrTrue') : i18n.t('postQuestions.toastrFalse')} `, `${body.name} ${i18n.t('postQuestions.txt')}`)
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestQuestionsFail(err));
          toastr.error('Erro');
          resolve('error');
        });
    })

  }
}

export const updateQuestions = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestQuestionsStart());
      API.put('/questions/' + index, body)
        .then(res => {
          dispatch(updateQuestionsSuccess(res.data));
          toastr.success(`${body.type === 'group' ? i18n.t('updateQuestions.toastrTrue') : i18n.t('updateQuestions.toastrFalse')} `, `${body.name}${i18n.t('updateQuestions.txt')}`)
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestQuestionsFail(err));
          toastr.error('Erro')
          resolve('error');
        });
    })
  }
}
